import React from 'react';
import styled, { css } from 'styled-components';
import { Label } from '~/components/atom/Typography';

export type Props = {
  dataTestId?: string;
};

const LabelContainer: React.FCC<Props> = ({ children, ...rest }) => (
  <Container {...rest}>{children}</Container>
);

const LABEL_WIDTH = 130;

const Container = styled(Label)(
  ({ theme }) => css`
    display: inline-block;
    min-width: ${LABEL_WIDTH}px;
    font-size: ${theme.fontSize('base')};
  `,
);

export default LabelContainer;
